import { render, staticRenderFns } from "./AgreementReport.vue?vue&type=template&id=2b8e8007"
import script from "./AgreementReport.vue?vue&type=script&lang=js"
export * from "./AgreementReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports